import React, { useRef, useState } from 'react';
import { ActivityIndicator, StyleSheet, View, Platform } from 'react-native';
import { WebView } from 'react-native-webview';
import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
export const WebViewFaqWithBack = (props:{ url: string, backFromFirstPageEvent?:()=>void }) => {

    const webViewRef = useRef();
    const [canGoBack, setCanGoBack] = useState(0);
    const shouldShowBack = props.backFromFirstPageEvent != null || canGoBack == true;
    const scale = defaultScale(1);
    const INJECTEDJAVASCRIPT = `
    const meta = document.createElement('meta'); 
    meta.setAttribute('content', 'initial-scale=${scale}'); 
    meta.setAttribute('name', 'viewport'); 
    document.getElementsByTagName('head')[0].appendChild(meta); `

;

    return (
        <View  style={{ height: '100%', width: '100%' }}>
        <WebView
            startInLoadingState
            javaScriptEnabled
            onMessage={(event) => {}}
            injectedJavaScript={INJECTEDJAVASCRIPT}
            ref={webViewRef}
            onNavigationStateChange={(navState => {setCanGoBack(navState.canGoBack === true)})}
            source={{ uri: props.url}}
            scalesPageToFit={Platform.OS === 'android' ? false : true}
            renderLoading={() =>
                <View style={styles.webviewLoading}>
                    <ActivityIndicator
                        animating
                        size='small'
                        color={Theme.PRIMARY}
                    />
                </View>
                }
            />
             <View  style={{ height: 100, width: '100%' }}>
                 { shouldShowBack &&
                    <Button
                    title={'Back'}
                    onPress={() => {
                        if (webViewRef.current.goBack != null && canGoBack) {
                            webViewRef.current.goBack();
                        } else if (props.backFromFirstPageEvent != null) {
                            props.backFromFirstPageEvent();
                        }
                    }}
                    fontColor={Theme.PRIMARY}
                    buttonType={ButtonTypes.TRANSPARENT}
                />
                 }

              </View>
        </View>
    );
};

const styles = StyleSheet.create({
    webviewLoading: {
        flex: 1,
        height: '100%',
        width: '100%',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: Theme.BLACK,
    },
});
